module.exports = __webpack_public_path__ + "static/barbarawork1-e3d113bcf0e8b28f68586ff2bb8d621c.jpg";